/**
 * Created by joerg on 20.05.17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Utils from '../utils/Utils';
import InputComponent from '../components/InputComponent';
import OutPutComponent from '../components/OutPutComponent';
import InputModel from '../models/InputModel'
import DropDown from '../components/DropDown'



@observer
export default class KostenanalyseHF extends React.Component {

    _onChange(e,entry){
        console.log('ch',e.target.value,entry)
        entry.value = e.target.value;
    }
    componentDidUpdate(){
        setTimeout(()=>{requestAnimationFrame(this._calcwidths);},200);

    }
    componentDidMount(){
        this.componentDidUpdate();
        window.jQuery('[data-toggle="tooltip"]').tooltip()
    }
    _calcwidths(){
        console.log('calcwidth')

        Utils.normalizeAddonWidths('#kostenanalyse_hf')



    }

    render (){
        const {dataStore,baseDataStore} = this.props;
      //  const self = this;
        var z = 200;
        return <div id="kostenanalyse_hf" className="well">
            <h4>{dataStore.title}</h4>
            <hr/>
            <div className="form-group zup" key={dataStore.lohnkosten.key} >

                <InputComponent inputModel={dataStore.lohnkosten} inputClasses={['size-input-height']}/>
            </div>
            {baseDataStore.detailEntries.map(entry => {
                    z--;
                    z--;
                    var styles = {zIndex : z};
                    if (entry instanceof InputModel) {
                        return( <div className="form-group zup" key={entry.key} style={styles}>

                            <InputComponent inputModel={entry} inputClasses={['size-input-height']}/>
                        </div>)
                    }else{
                        return (<div key={entry.key} className="form-group zup" style={styles}>
                            <div className="input-group" style={{width:'100%'}} >
                                <div className="input-group-addon left-addon-dd" dangerouslySetInnerHTML={{__html: entry.title}}></div>
                                <div className="input-group-btn ">
                                    <DropDown key={entry.key} dataProvider={entry} onSelect={entry.onSelect}/>
                                </div>
                            </div>
                        </div>)
                    }
                }
            )}

            {dataStore.entries.map(entry => {
                z--;
                z--;
                var styles = {zIndex : z};
                if (entry instanceof InputModel) {
                    return( <div className="form-group zup" key={entry.key} style={styles}>

                        <InputComponent inputModel={entry} inputClasses={['size-input-height']}/>
                    </div>)
                }else{
                    return (<div key={entry.key} className="form-group zup" style={styles}>
                        <div className="input-group" style={{width:'100%'}} >
                            <div className="input-group-addon left-addon-dd" dangerouslySetInnerHTML={{__html: entry.title}}></div>
                            <div className="input-group-btn ">
                                <DropDown key={entry.key} dataProvider={entry} onSelect={entry.onSelect}/>
                            </div>
                        </div>
                    </div>)
                }
                }
            )}
            {/*<div className="form-group zup" >
                <OutPutComponent outputModel={dataStore.totalValue} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                <OutPutComponent outputModel={dataStore.totalValueBrespa} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
            </div>*/}
        </div>;
    }

}

KostenanalyseHF.propTypes = {
    dataStore: PropTypes.object.isRequired,
    baseDataStore: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/components/KostenanalyseHF.js